import { useMemo } from "react";
import { AnalyticsCampaign } from "../../../types";

export function useDataSendOut(analyticsData: AnalyticsCampaign[] | undefined) {
  return useMemo(
    () => ({
      data: analyticsData?.map((dataItem, index) => ({
        label: "Send out",
        value: dataItem.amountReached,
        backgroundColor: index === 0 ? "rgba(99, 102, 241, 0.5)" : undefined,
      })),
      subtitle: analyticsData?.reduce(
        (acc, curr) => acc + curr.amountReached,
        0
      ),
    }),
    [analyticsData]
  );
}
